export default __webpack_public_path__ + "57b905ba61590bf0ebdaa1cd40527eac.png";